<template>
  <div>
    <div
      v-if="photosTitle || photosDescription"
      class="carousel-intro"
    >
      <h2 v-if="photosTitle">
        {{ photosTitle }}
      </h2>
      <p v-if="photosDescription">
        {{ photosDescription }}
      </p>
    </div>
    <div
      v-if="childcareResultSlides"
      class="photos"
      :class="randomPhotoClassFirst"
    >
      <div
        v-for="(result, index) in childcareResultSlides.slice(0, 4)"
        :key="index"
        class="photos-inner"
        :class="[`photos-inner-${index}`]"
      >
        <img

          :src="result.childcareResultImage"
          alt=""
          class="photos-image"
        >
        <kf-button
          class="photos-btn"
          @click="startPositionSlide(index)"
        />
        <div class="photos-content">
          <span class="photos-content-title">
            {{ result.childcareResultTitle }}
          </span>
          <p class="photos-content-description">
            {{ result.childcareResultDescription }}
          </p>
        </div>
      </div>
      <modal
        v-show="photosModalIsOpen"
        :modal="true"
        class="photos-modal"
        @close="closeModal"
      >
        <template slot="body">
          <kf-carousel
            v-if="activeCarousel"
            :carousel-slides="childcareSlides"
            :carousel-per-view="1"
            :carousel-show-arrows="true"
            :carousel-show-bullets="false"
            :carousel-rewind="true"
            :carousel-gap="25"
            :carousel-start-at="currentSliderNumber"
            :carousel-peek="{
              before: 0,
              after: 0,
            }"
          />
        </template>
      </modal>
    </div>
    <div
      v-if="childcareResultSlides ? childcareResultSlides.length > 4 : null"
      class="photos"
      :class="randomPhotoClassSecond"
    >
      <div
        v-for="(result, index) in childcareResultSlides.slice(4, 8)"
        :key="index"
        class="photos-inner"
        :class="[`photos-inner-${index}`]"
      >
        <img

          :src="result.childcareResultImage"
          alt=""
          class="photos-image"
        >
        <kf-button
          class="photos-btn"
          @click="startPositionSlide(index + 4)"
        />
        <div class="photos-content">
          <span class="photos-content-title">
            {{ result.childcareResultTitle }}
          </span>
          <p class="photos-content-description">
            {{ result.childcareResultDescription }}
          </p>
        </div>
      </div>
      <modal
        v-show="photosModalIsOpen"
        :modal="true"
        class="photos-modal"
        @close="closeModal"
      >
        <template slot="body">
          <kf-carousel
            v-if="activeCarousel"
            :carousel-slides="childcareSlides"
            :carousel-per-view="1"
            :carousel-show-arrows="true"
            :carousel-show-bullets="false"
            :carousel-rewind="true"
            :carousel-gap="25"
            :carousel-start-at="currentSliderNumber"
            :carousel-peek="{
              before: 0,
              after: 0,
            }"
          />
        </template>
      </modal>
    </div>
  </div>
</template>

<script>
import KfButton from '@/components/base/button/Button.vue';
import KfCarousel from '@/components/carousel/Carousel.vue';
import Modal from '@/components/modal/Modal.vue';

export default {
  name: 'KfPhotos',
  components: {
    KfButton,
    KfCarousel,
    Modal,
  },
  props: {
    i18n: {
      type: Object,
      default: () => {},
    },
    photosTitle: {
      type: String,
      default: '',
    },
    photosDescription: {
      type: String,
      default: '',
    },
    childcareResultSlides: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      currentSliderNumber: undefined,
      photosModalIsOpen: false,
      photoClassNameList: ["photos-a", "photos-b", "photos-c"],
    };
  },
  computed: {
    childcareSlides() {
      return this.childcareResultSlides.map(
        item =>
          ({
            imageUrl: item.childcareResultImage,
            caption: item.childcareResultTitle,
            description: item.childcareResultDescription,
          })
        );
    },
    activeCarousel() {
      return this.currentSliderNumber === 0 || this.currentSliderNumber > 0;
    },
    randomPhotoClassFirst() {
      // eslint-disable-next-line security-node/detect-insecure-randomness
      return this.photoClassNameList[Math.floor(Math.random() * this.photoClassNameList.length)]
    },
    randomPhotoClassSecond() {
      // eslint-disable-next-line security-node/detect-insecure-randomness
      return this.photoClassNameList[Math.floor(Math.random() * this.photoClassNameList.length)]
    },
  },
  methods: {
    startPositionSlide(i) {
      this.$nextTick(() => {
      this.photosModalIsOpen = true;

        this.currentSliderNumber = i;
      })
    },
    closeModal() {
      this.photosModalIsOpen = false;
      this.currentSliderNumber = undefined;
    },
  }
};
</script>

<style lang="postcss">
.photos {
  @apply grid mt-10;
  grid-auto-rows: 55px;
  gap: 3%;
  grid-row-gap: 10px;

  &.photos-a {
    grid-template-columns: 28% 33% 33%;
    grid-template-areas:
      'image1 image3 image4'
      'image2 image3 image4';
  }

  &.photos-b {
    grid-template-columns: 33% 33% 28%;
    grid-template-areas:
      'image1 image2 image3'
      'image1 image2 image4';
  }

  &.photos-c {
    grid-template-columns: 33% 28% 33%;
    grid-template-areas:
      'image1 image2 image4'
      'image1 image3 image4';
  }

  @screen xs {
    grid-auto-rows: 65px;
    grid-row-gap: 20px;
  }

  @screen sm {
    grid-auto-rows: 90px;
    grid-row-gap: 20px;
  }

  @screen md {
    grid-auto-rows: 112px;
    grid-row-gap: 20px;
  }

  @screen lg {
    grid-auto-rows: 147px;
    grid-row-gap: 25px;
  }

  @screen xl {
    grid-auto-rows: 180px;
    grid-row-gap: 30px;
  }

  @screen 2xl {
    grid-row-gap: 40px;
  }

  &-inner {
    @apply relative  w-full h-full;

    &::after {
      @apply  absolute top-0 right-0 bottom-0 left-0 rounded overflow-hidden;
      content: "";
      background: linear-gradient(0deg, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0) 50%);
      z-index: 1;
    }

    &:nth-child(4n+1) {
      grid-area: image1;
    }

    &:nth-child(4n+2) {
      grid-area: image2;
    }

    &:nth-child(4n+3) {
      grid-area: image3;
      align-self: flex-start;
    }

    &:nth-child(4n+4) {
      grid-area: image4;
      align-self: flex-end;
    }

    &:nth-child(4n+5) {
      grid-area: image5;
    }

    &:nth-child(4n+6) {
      grid-area: image6;
    }

    &:nth-child(4n+7) {
      grid-area: image7;
      align-self: flex-start;
    }

    &:nth-child(4n+8) {
      grid-area: image8;
      align-self: flex-end;
    }

    &:nth-child(2),
    &:nth-child(3),
    &:nth-child(6),
    &:nth-child(7) {
      .photos-content {
        @apply hidden;
      }
    }

  }

  &-btn {
    @apply absolute top-0 right-0 bottom-0 left-0;
    z-index: 9;
  }

  &-content {
    @apply hidden absolute bottom-0 w-full p-5;
    z-index: 2;

    @screen md {
      @apply inline-block;
    }

    &-title {
      @apply block text-sm text-primary-bravo mb-3;
    }

    &-description {
      @apply text-white text-base mb-0;
    }
  }

  &-image {
    @apply block object-cover object-center h-full w-full rounded;
  }

  .no-images {
    @apply text-black text-sm underline ml-8;
  }

  &-modal {
    .modal-overlay {
      @apply opacity-100 bg-white;
    }

    .modal {
      max-width: none;
      max-height: none;
      box-shadow: none;

      &-header {
        @apply border-0;
      }
    }

    .carousel {
      margin-left: 0;

      .glide__track {
        padding-left: 0;
      }

      .glide__slide {
        @apply flex justify-center;
      }

      div[data-glide-el=controls] .glide__arrow--left {
        left: -18px;
      }

      &-card {
        max-width: 600px;
      }
    }
  }

}

</style>
